import clsx from 'clsx';
import { useState } from 'react';

import styles from './FaqItem.module.scss';

export interface FaqItemProps {
  key: number;
  question: string;
  lineOne: string | JSX.Element;
  lineTwo?: string | JSX.Element;
}

export const FaqItem = ({ question, lineOne, lineTwo }: FaqItemProps) => {
  const [open, setOpen] = useState(false);

  return (
    <li className={styles.block}>
      <button
        className={clsx(styles.question, {
          [styles.open]: open,
        })}
        onClick={() => setOpen(!open)}
      >
        <h3>{question}</h3>
      </button>
      {open && (
        <div className={styles.answer}>
          <p>{lineOne}</p>
          {lineTwo && <p>{lineTwo}</p>}
        </div>
      )}
    </li>
  );
};
